import { render } from "./ExpertMode.vue?vue&type=template&id=c460691c&scoped=true"
import script from "./ExpertMode.vue?vue&type=script&lang=js"
export * from "./ExpertMode.vue?vue&type=script&lang=js"

import "./ExpertMode.vue?vue&type=style&index=0&id=c460691c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c460691c"]])

export default __exports__